import "pixi";
import "phaser";

import * as i18n from "../i18n";
import * as logging from "../logging";
import AudioEngine from "../audio_engine";
import MuteButton from "../ui/mute";

import { BlurX, BlurY } from "../effects/blur";

export default class TitleState extends Phaser.State {

    count: number;
    bg: Phaser.Sprite;
    title: Phaser.Sprite;
    title_top: Phaser.Sprite;
    title_bottom: Phaser.Sprite;
    cut: Phaser.Sprite;
    play_button: i18n.Text;
    credits_button: i18n.Text;
    play_triangle: Phaser.Sprite;
    flags: Array<Flag>;

    tmap: TweenMap;

    triTween: Phaser.Tween | null;

    hover_play: boolean;
    fast: boolean;
    isRestart: boolean;

    mute_button: MuteButton;

    init(fast=false, isRestart=false) {
        this.fast = fast;
        this.isRestart = isRestart;
    }

    create() {
        this.count = 0;
        this.game.stage.backgroundColor = "#FFFFFF";

        this.bg = this.game.add.sprite(0, 0, "background2");
        this.bg.width = this.game.width;
        this.bg.height = this.game.height;
        this.bg.alpha = 1;

        this.title = this.game.add.sprite(400, 220, "title-whole");
        this.title.anchor.setTo(0.5, 0.5);
        this.title.alpha = 0;

        this.title_bottom = this.game.add.sprite(400, 240, "title-bottom");
        this.title_bottom.anchor.setTo(0.5, 0.5);
        this.title_bottom.alpha = 0;

        this.title_top = this.game.add.sprite(400, 240, "title-top");
        this.title_top.anchor.setTo(0.5, 0.5);
        this.title_top.alpha = 0;

        this.cut = this.game.add.sprite(400, 240, "cut");
        this.cut.anchor.setTo(0.5, 0.5);
        this.cut.alpha = 0;
        this.cut.angle = 78.5;
        this.cut.filters = [ new BlurX(this.game, 1536), new BlurY(this.game, 1536) ];

        this.play_button = i18n.label(this.game, 400, 400, i18n._("PLAY"), "font-small", 32);
        this.play_button.anchor.setTo(0.5, 0.5);
        this.play_button.alpha = 0;

        this.play_triangle = this.game.add.sprite(340, 400, "triangle");
        this.play_triangle.anchor.setTo(0.5, 0.5);
        this.play_triangle.alpha = 0;

        this.credits_button = i18n.label(this.game, 400, 464, i18n._("CREDITS & PRIVACY"), "font-small", 32);
        this.credits_button.anchor.setTo(0.5, 0.5);
        this.credits_button.alpha = 0;

        this.triTween = null;

        let language = i18n.getLanguage();

        this.flags = [];
        this.flags.push(new Flag(this.game, "america-flag", 310, 550, "en", ("en" == language)));
        this.flags.push(new Flag(this.game, "china-flag", 370, 550, "cn", ("cn" == language)));
        this.flags.push(new Flag(this.game, "japan-flag", 430, 550, "jp", ("jp" == language)));
        this.flags.push(new Flag(this.game, "korea-flag", 490, 550, "kr", ("kr" == language)));

        this.tmap = {};
        this.tmap['playTriangleSlide'] = this.game.add.tween(this.play_triangle).to( { x: 350 }, 80, "Linear", true, 0, 0, true);
        this.tmap['playTriangleSlide'].onLoop.add(() => {
            this.tmap['playTriangleSlide'].pause();
        });
        this.tmap['playTriangleSlide'].pause();

        const animScale = this.fast ? 0.25 : 1.0;
        this.tmap['titleFadeIn'] = this.game.add.tween(this.title).to( { alpha: 1 }, 1000 * animScale, Phaser.Easing.Cubic.InOut);
        this.tmap['titleSlideIn'] = this.game.add.tween(this.title).to( { y: 240 }, 1000 * animScale, Phaser.Easing.Cubic.InOut);
        this.tmap['cutFadeIn'] =  this.game.add.tween(this.cut).to( { alpha: 1 }, 166, "Linear");
        this.tmap['backgroundSlightFadeOut'] =  this.game.add.tween(this.bg).to( { alpha: 0.9 }, 166, "Linear");
        this.tmap['topSlideX'] =  this.game.add.tween(this.title_top).to( { x: 397 }, 250, "Linear");
        this.tmap['topSlideY'] =  this.game.add.tween(this.title_top).to( { y: 241 }, 250, "Linear");
        this.tmap['cutFadeOut'] =  this.game.add.tween(this.cut).to( { alpha: 0.1 }, 166, "Linear");
        this.tmap['backgroundSlightFadeIn'] =  this.game.add.tween(this.bg).to( { alpha: 1 }, 166, "Linear");
        this.tmap['playButtonFadeIn'] =  this.game.add.tween(this.play_button).to( { alpha: 1 }, 800 * animScale, "Linear");
        this.tmap['creditsButtonFadeIn'] =  this.game.add.tween(this.credits_button).to( { alpha: 0.6 }, 800 * animScale, "Linear");
        this.tmap['playTriangleFadeIn'] =  this.game.add.tween(this.play_triangle).to( { alpha: 1 }, 800 * animScale, "Linear");

        this.tmap['titleFadeIn'].start();
        this.tmap['titleSlideIn'].start();

        this.tmap['titleFadeIn'].onComplete.add(() =>{
            this.tmap['cutFadeIn'].start();
            this.tmap['backgroundSlightFadeOut'].start();
        });

        this.tmap['cutFadeIn'].onComplete.add(() =>{
            this.title.alpha = 0;
            this.title_top.alpha = 1;
            this.title_bottom.alpha = 1;
            this.tmap['topSlideX'].start();
            this.tmap['topSlideY'].start();
        });

        this.tmap['topSlideX'].onComplete.add(() =>{
            this.tmap['cutFadeOut'].start();
            this.tmap['backgroundSlightFadeIn'].start();
        });

        this.tmap['cutFadeOut'].onComplete.add(() =>{
            this.tmap['playButtonFadeIn'].start();
            this.tmap['creditsButtonFadeIn'].start();
            this.tmap['playTriangleFadeIn'].start();

            for(let f of this.flags){
                this.game.add.tween(f.flagSprite).to( { alpha: (f.isSelected ? 1 : 0.3) }, 800, "Linear", true);
            }

        });

        this.tmap['playButtonFadeIn'].onComplete.add(() =>{
            this.play_button.inputEnabled = true;
            this.play_button.input.useHandCursor = true;
            this.play_button.events.onInputDown.add(this.go_play, this);
            this.play_button.events.onInputOver.add(this.on_hover, this);
            this.play_button.events.onInputOut.add(this.out_hover, this);
            this.credits_button.inputEnabled = true;
            this.credits_button.input.useHandCursor = true;
            this.credits_button.events.onInputDown.add(this.goCredits, this);
            this.credits_button.events.onInputOver.add(() => {
                this.credits_button.alpha = 1.0;
            });
            this.credits_button.events.onInputOut.add(() => {
                this.credits_button.alpha = 0.6;
            });
            this.play_triangle.inputEnabled = true;
            this.play_triangle.input.useHandCursor = true;
            this.play_triangle.events.onInputDown.add(this.go_play, this);
            this.play_triangle.events.onInputOver.add(this.on_hover, this);
            this.play_triangle.events.onInputOut.add(this.out_hover, this);

            for(let f of this.flags){
                f.flagSprite.inputEnabled = true;
                f.flagSprite.input.useHandCursor = true;
                f.flagSprite.events.onInputDown.add(() => {this.changeLanguage(f.id)}, this);
                f.flagSprite.events.onInputOver.add(() => {f.onHover()}, this);
                f.flagSprite.events.onInputOut.add(() => {f.outHover()}, this);
            }
        });

        if (!this.isRestart) {
            logging.startLevel(logging.LEVEL_TITLE, null);
            logging.logAction(logging.Action.CurrentLanguage, {
                "language": i18n.getLanguage(),
            });
        }

        AudioEngine.get().startMusic();
        this.mute_button = new MuteButton(this.game, () =>{
            AudioEngine.get().mute();
        },
        () => {
            AudioEngine.get().unmute();
        }, 2000);
    }

    changeLanguage(id: string) {
        localStorage.setItem("language", id);
        i18n.setLanguage(<i18n.Language>id);
        logging.logAction(logging.Action.ChangeLanguage, {
            "language": id,
        });
        this.game.state.restart(true, false, true, true);
    }

    go_play() {
        logging.finishLevel();
        this.state.start('level-select');
    }

    goCredits() {
        logging.finishLevel();
        this.state.start('credits');
    }

    on_hover(item: Phaser.Sprite) {
        if(this.triTween != null){
            this.triTween.stop();
        }
        this.triTween = this.game.add.tween(this.play_triangle).to( { x: 350 }, 60, "Linear", true);

    }

    out_hover(item: Phaser.Sprite) {
        if(this.triTween != null){
            this.triTween.stop();
        }
        this.triTween = this.game.add.tween(this.play_triangle).to( { x: 340 }, 60, "Linear", true);
    }

    render() {
    }

    reset() {
    }

    update() {
        if (!logging.PRODUCTION && this.game.input.keyboard.isDown(Phaser.KeyCode.SPACEBAR)) {
            this.go_play();
        }
    }
}

class Flag {
    game: Phaser.Game;
    flagSprite: Phaser.Sprite;
    id: string;
    flagTween: Phaser.Tween;
    isSelected: boolean;

    constructor(game: Phaser.Game, name: string, x: number, y: number, id: string, isSelected: boolean) {
        this.game = game;
        this.id = id;
        this.isSelected = isSelected;

        this.flagSprite = this.game.add.sprite(x, y, name);
        this.flagSprite.anchor.setTo(0.5, 0.5);
        this.flagSprite.alpha = 0;

    }

    onHover(){
        if(this.flagTween != null){
            this.flagTween.stop();
        }
        this.flagTween = this.game.add.tween(this.flagSprite).to( { alpha: 1 }, 60, "Linear", true);
    }

    outHover(){
        if(this.flagTween != null){
            this.flagTween.stop();
        }
        if(this.isSelected){
            this.flagTween = this.game.add.tween(this.flagSprite).to( { alpha: 1 }, 60, "Linear", true);
        }
        else {
            this.flagTween = this.game.add.tween(this.flagSprite).to( { alpha: 0.3 }, 60, "Linear", true);
        }
    }
}

interface TweenMap {
    [key: string]: Phaser.Tween;
}



// WEBPACK FOOTER //
// ./src/states/title.ts